
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { InputBorderType_Enum } from '../../enums/InputBorderType_Enum'
import CFInput from './CFInput'

	@Component({
	  name: 'InputDateOfBirth'
	})
export default class InputDateOfBirth extends Vue implements CFInput {
		@Prop() id!: string;
		@Prop({ default: '' }) name!: string;
		@Prop() value!: Date | null;
		@Prop({ default: null }) min!: Date | null;
		@Prop({ default: null }) max!: Date | null;
		@Prop({ default: true }) showPlaceholder!: boolean;
		@Prop({ default: InputBorderType_Enum.underlined }) borderType!: InputBorderType_Enum;

		val: Date | null = null;

		day: number | null = null;
		month: number | null = null;
		year: number | null = null;

		showError = false;
		showAgeError = false;

		@Watch('value', { immediate: true })
		set () {
		  if (!this.value) {
		    return
		  }

		  const d = new Date(this.value)
		  this.val = this.value
		  this.day = d.getDate()
		  this.month = d.getMonth() + 1
		  this.year = d.getFullYear()
		}

		@Watch('val', { immediate: true, deep: true })
		update () {
		  this.$emit('input', this.val)
		}

		getAge () {
		  const today = new Date()
		  let age = today.getFullYear() - this.val!.getFullYear()
		  var m = today.getMonth() - this.val!.getMonth()
		  if (m < 0 || (m === 0 && today.getDate() < this.val!.getDate())) {
		    age--
		  }
		  return age
		}

		validate () {
		  const dayValid = this.validateDay()
		  const monthValid = this.validateMonth()
		  const yearValid = this.validateYear()

		  this.trimDate()

		  if (!dayValid || !monthValid || !yearValid) {
		    this.showError = true
		    this.val = null
		    return false
		  }

		  this.showAgeError = false
		  this.showError = false

		  this.val = new Date(this.year!, this.month! - 1, this.day!)

		  if (this.getAge() < 18) {
		    this.showAgeError = true
		    return false
		  }

		  return true
		}

		validateDay () {
		  const showDayError = !(this.$refs['dobDay' + this.id] as unknown as CFInput).validate()

		  if (showDayError) {
		    return false
		  }

		  this.day = this.day! < 1 ? 1 : this.day! > 31 ? 31 : this.day

		  if (this.month !== null) {
		    this.trimDate()
		  }

		  this.showError = false

		  return true
		}

		validateMonth () {
		  const showMonthError = !(this.$refs['dobMonth' + this.id] as unknown as CFInput).validate()

		  if (showMonthError) {
		    return false
		  }

		  this.month = this.month! < 1 ? 1 : this.month! > 12 ? 12 : this.month

		  this.showError = false

		  // trim date
		  if (this.day !== null) {
		    this.trimDate()
		  }

		  return true
		}

		validateYear () {
		  const showYearError = !(this.$refs['dobYear' + this.id] as unknown as CFInput).validate()

		  if (showYearError) {
		    return false
		  }

		  this.showError = false

		  return true
		}

		trimDate () {
		  if ([4, 6, 9, 11].includes(Number(this.month!)) && Number(this.day!) > 30) {
		    this.day = 30
		  }

		  if (Number(this.month!) === 2 && Number(this.day!) > 28) {
		    this.day = 28
		  }
		}

		input (val: number, part: string) {
		  this.showError = false
		  if (part === null || val === null) {
		    return
		  }

		  switch (part) {
		    case 'day':
		      this.day = val
		      if (this.day!.toString().length === 2) {
		        const comp = (this.$refs['dobMonth' + this.id] as unknown as CFInput)
		        if (comp) {
							comp.focus!()
		        }
		      }
		      break
		    case 'month':
		      this.month = val
		      if (this.month!.toString().length === 2) {
		        const comp = (this.$refs['dobYear' + this.id] as unknown as CFInput)
		        if (comp) {
							comp.focus!()
		        }
		      }
		      break
		  }
		}

		// #region Computed

		get monthInput () {
		  return this.$refs['dobMonth' + this.id]
		}

		get cssClass () {
		  return this.showError ? 'error' : ''
		}

		get minYear () {
		  return this.min ? this.min.getFullYear() : new Date().getFullYear() - 100
		}

		get maxYear () {
		  return this.max ? this.max.getFullYear() : new Date().getFullYear() - 16
		}

		// #endregion

		// #region Watches

		@Watch('day')
		@Watch('month')
		@Watch('year')
		tryParse () {
		  this.showError = false
		}
}
